
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { MedicationForm } from "./MedicationForm";

export const MedicationHeader = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div>
          <h1 className="text-4xl font-bold">Médicaments</h1>
          <p className="text-muted-foreground mt-2">
            Gérez tous vos médicaments et traitements en un seul endroit
          </p>
        </div>
        <Button 
          className="bg-primary hover:bg-primary/90"
          onClick={() => setOpen(true)}
        >
          <Plus className="mr-2 h-4 w-4" /> Ajouter un médicament
        </Button>
      </div>
      <MedicationForm open={open} onOpenChange={setOpen} />
    </>
  );
};
